import fetchJsonp from 'fetch-jsonp';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

const useStackMap = () => {
  const currentLibrary = useSelector(selectCurrentLibrary);
  const settings = currentLibrary.get('stackMap')?.toJS();

  const [state, setState] = useState({
    hasError: false,
    isFetching: false,
    results: null,
    settings
  });

  const fetchMap = (domain, data) => {
    const queryString = new URLSearchParams(data).toString();
    const url = `https://${domain}.stackmap.com/json/?${queryString}&callback=`;

    setState(prevState => {
      return {
        ...prevState,
        isFetching: true,
        results: null
      };
    });

    return fetchJsonp(url, { timeout: 10000 })
      .then(response => response.json())
      .then(res => {
        const { results, stat } = res;

        const hasError = stat !== 'OK';

        setState(prevState => {
          return {
            ...prevState,
            hasError,
            isFetching: false,
            results
          };
        });
      })
      .catch(() => {
        setState(prevState => {
          return {
            ...prevState,
            hasError: true,
            isFetching: false
          };
        });
      });
  };

  return { fetchMap, state };
};

export default useStackMap;
